import { render, staticRenderFns } from "./payment-list.vue?vue&type=template&id=6ed8a919&"
import script from "./payment-list.vue?vue&type=script&lang=js&"
export * from "./payment-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports